__turbopack_context__.v({
  "answer-container": "_7X-fNq_answer-container",
  "qa-card": "_7X-fNq_qa-card",
  "qa-card-text": "_7X-fNq_qa-card-text",
  "qa-container": "_7X-fNq_qa-container",
  "qa-letter-icon": "_7X-fNq_qa-letter-icon",
  "question": "_7X-fNq_question",
});
